// 更新state数据(插入，更新)
const changeState = function (name, state, data) {
  if (typeof data === 'undefined') return;
  localStorage[name] = JSON.stringify(data);
  state[name] = data;
};

const changeSessionState = function (name, state, data) {
  if (typeof data === 'undefined') return;
  sessionStorage[name] = JSON.stringify(data);
  state[name] = data;
};


export default {
  // 权限Token
  TOKEN: (state, data) => {
    state.token = data;
    localStorage.token = data;
  },
  // 基础信息
  BASEINFO: (state, data) => {
    changeState('baseInfo', state, data);
  },
  // 基础信息
  BASEINFOMOBILE: (state, data) => {
    changeState('baseInfoMobile', state, data);
  },
  // 重定向路由路径
  REDIRECT: (state, data) => {
	  changeState('redirectUrl', state, data);
  },
  // 位置信息
  LOCATION: (state, data) => {
    changeSessionState('location', state, data);
  },
  // 购物车信息
  CART: (state, data) => {
	  changeState('cartData', state, data);
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js